import classNames from 'classnames';
import { forwardRef } from 'react';
import styles from './Button.module.scss';

/**
 * Button
 *
 * @return {JSX.Element}
 */
const Button = (
  {
    className,
    title,
    children,
    success,
    blue,
    white,
    reverse,
    square,
    transparent,
    flex,
    type = 'button',
    warn,
    noPadding,
    big,
    ...rest
  },
  ref
) => {
  return (
    <button
      ref={ref}
      className={classNames(
        styles.Button,
        className,
        success && styles.Button__success,
        blue && styles.Button__blue,
        white && styles.Button__white,
        warn && styles.Button__warn,
        reverse && styles.Button__reverse,
        square && styles.Button__square,
        transparent && styles.Button__transparent,
        flex && styles.Button__flex,
        noPadding && styles.Button__noPadding,
        big && styles.Button__big,
        `${Button.displayName}`
      )}
      type={type}
      {...rest}
    >
      {title || children}
    </button>
  );
};

Button.displayName = 'Button';

export default forwardRef(Button);
